export default __webpack_public_path__ + "static/media/logo2.438ffa2f.png";